import { useEffect, useState, useRef } from "react";
import { Container, Row, Col, Button, Card, Accordion, Modal } from "react-bootstrap";
import EnquiryModal from "../components/EnquiryModal"
import SectionHeading from "../components/SectionHeading";
import FeatureCard from "../components/FeatureCard";
import NumberedCard from "../components/NumberedCard";
import StepCard from "../components/StepCard";
import PricingCard from "../components/PricingCard";
import { ArrowUpRight } from "lucide-react";
import {
  CalendarCheck,
  Users,
  Bell,
  FlaskConical,
  Stethoscope,
  TrendingUp,

} from "lucide-react";


import "../styles/landing.scss";
import LandingPageHero from "../assets/images/LandingPageMain.png"
import LandingPage2 from "../assets/images/landingPage2.png"
import { useLocation } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import { scroller } from "react-scroll";
import administrativeImage from "../assets/images/allDoc.png";
import patientImage from "../assets/images/patientbed.png";
import labTechnician from "../assets/images/lab-hero.png";
import receptionistImage from "../assets/images/hospitalNetwork1.png";
import opdImage from "../assets/images/IPD1.png";
import payrollImage from "../assets/images/IPDHero.png";
import bloodbankImage from "../assets/images/bloodHand.png";
import cssdImage from "../assets/images/CSSDHero.png";
import csImage from "../assets/images/allDoc.png";
import ipdImage from "../assets/images/IPD1.png";
import tpaImage from "../assets/images/TPA2.png";
import doctorsImage from "../assets/images/doctorHero.png";
import lisrisImage from "../assets/images/TPAHero.png";
import pharmacyImage from "../assets/images/pharmacyHero.png";
import mrdImage from "../assets/images/allDoc.png";
import biowasteImage from "../assets/images/LISHero.png";
import purchaseImage from "../assets/images/allDoc.png";
import crmImage from "../assets/images/allDoc.png";
import accountImage from "../assets/images/hospitalNetwork1.png";
import assetImage from "../assets/images/allDoc.png";
import ambulanceImage from "../assets/images/allDoc.png";
import integration from "../assets/images/integration.png";
import medicaltest from "../assets/images/medicaTeam.png";
import calender from "../assets/images/calendar.png";



import patient from "../assets/images/landingpage/doctor.png";//ok
import receptionist from "../assets/images/landingpage/receptionist.png";//ok
import opd from "../assets/images/landingpage/website.png";//ok
import payroll from "../assets/images/landingpage/salary.png";//ok
import bloodbank from "../assets/images/landingpage/bloodbank.png";//ok
import cssd from "../assets/images/landingpage/department.png";//ok
import tpa from "../assets/images/landingpage/mediator.png";//ok
import doctor from "../assets/images/landingpage/doctor.png";//ok
import pharmacy from "../assets/images/landingpage/pharmacy.png";//ok
import mrd from "../assets/images/landingpage/medicalreport.png";
import biowaste from "../assets/images/landingpage/recyclebin.png";//ok
import crm from "../assets/images/landingpage/crm.png";//ok
import accounts from "../assets/images/landingpage/accounting.png";//ok
import asset from "../assets/images/landingpage/assets.png";//ok
import ambulance from "../assets/images/landingpage/ambulance.png";//ok
import daycare from "../assets/images/landingpage/operation.png";//ok
import labtechnician from "../assets/images/landingpage/administrator.png";//ok
import lis from "../assets/images/landingpage/housekeeper.png";//ok



const BASE_URL = process.env.REACT_APP_BASE_URL;
{/*Core Modules */ }
const modulesData = {
  Administrative: {
    points: [
      "Record patients’ vitals and maintain them in the Treatment Order Sheet",
      "Create a Drug Plan for your patients and ensure its administration",
      "Real Time Request to Laboratory, Pharmacy, and other Departments",
      "Communicate with consultants on the go and execute tasks in real-time",
    ],
    image:administrativeImage,
  },
  Patient: {
    points: [
      "Centralized patient registration and profile management",
      "Track appointments and visit history",
      "View prescriptions and reports",
    ],
    image: patientImage ,
  },
  "Lab/Technician": {
    points: [
      "Manage lab test requests",
      "Upload and verify reports",
      "Track sample collection and status",
    ],
    image: labTechnician ,
  },
  Receptionist: {
    points: [
      "Handle patient appointments",
      "Billing and front-desk operations",
      "Doctor availability coordination",
    ],
    image: receptionistImage ,
  },
  "OPD/Daycare": {
    points: [
      "OPD workflow management",
      "Daycare admission & discharge",
      "Doctor consultation tracking",
    ],
    image: opdImage ,
  },

  Payroll: { points: ["Employee salary processing"], image: payrollImage },
  "Blood Bank": { points: ["Blood stock management"], image: bloodbankImage },
  CSSD: { points: ["Sterilization tracking"], image: cssdImage },
  CS: { points: ["Central Sterilization & Services"], image: csImage },
  "IPD & Emergency": { points: ["Emergency & ward management"], image: ipdImage },
  TPA: { points: ["Insurance & claim processing"], image: tpaImage },
  Doctor: { points: ["Doctor schedules & cases"], image: doctorsImage },
  "LIS/RIS": { points: ["Lab & radiology system"], image: lisrisImage },
  Pharmacy: { points: ["Medicine inventory & billing"], image: pharmacyImage },
  MRD: { points: ["Medical records management"], image: mrdImage },
  "Bio Waste": { points: ["Waste disposal tracking"], image: biowasteImage },
  "Purchase & Inventory": { points: ["Stock & vendor management"], image: purchaseImage },
  CRM: { points: ["Patient engagement"], image: crmImage },
  Accounts: { points: ["Hospital accounting"], image: accountImage },
  Asset: { points: ["Equipment tracking"], image: assetImage },
  Ambulance: { points: ["Ambulance request & tracking"], image: ambulanceImage },
};

const features = [
  {
    title: "Data residency",
    description: "Hosted in India (AWS Mumbai/Hyderabad). In-region backups.",
    image: calender,
  },
  {
    title: "Privacy",
    description:
      "DPDPA-aligned consent, purpose limitation, minimization & deletion workflows.",
    image: calender,
  },
  {
    title: "Access control",
    description: "Role-based permissions, optional MFA, IP allow-listing/VPN.",
    image: calender,
  },
  {
    title: "Auditability",
    description: "Detailed activity logs and exports.",
    image: medicaltest,
  },
  {
    title: "ABDM-ready",
    description:
      "FHIR R4 adapters for ABHA/Consent Manager* (activation post sandbox verification).",
    image: medicaltest,
  },
];

const integrations = [
  {
    title: "Messaging",
    description: "MSG91, Gupshup, Karix; WhatsApp via approved WABA/BSP.",
  },
  {
    title: "Identity",
    description: "OAuth2/SAML (optional).",
  },
  {
    title: "Labs/EHR",
    description: "REST JSON & webhooks; HL7/FHIR bridges as needed.",
  },
  {
    title: "Data export",
    description: "CSV/PDF/JSON; scheduled exports on request.",
  },
];
const moduleTabs = ["Administrative", "Patient", "Lab/Technician", "Receptionist", "OPD/Daycare", "Payroll", "Blood Bank", "CSSD", "IPD & Emergency", "TPA", "Doctor", "LIS/RIS", "Pharmacy", "MRD", "Bio Waste", "Purchase & Inventory", "CRM", "Accounts", "Asset", "Ambulance",];

// Why Section Features
const whyFeatures = [
  {
    icon: CalendarCheck,
    title: "Everything in one place",
    description: "Scheduling, patient records, lab workflows, and e-prescriptions.",
    iconSize: 30,
  },
  {
    icon: Users,
    title: "Built for teams",
    description: "Super-Admin, Admin, Doctor, Receptionist, Lab/Technician, and Patient portals.",
    iconSize: 26,
  },
  {
    icon: Bell,
    title: "Reduce no-shows",
    description: "Smart reminders via Email/SMS/WhatsApp with flexible cadences.",
    iconSize: 26,
  },
  {
    icon: FlaskConical,
    title: "Faster lab TAT",
    description: "Structured test requests, real-time status, instant result delivery.",
    iconSize: 30,
  },
];

// How It Works Steps
const howItWorksSteps = [
  {
    number: "01",
    icon: CalendarCheck,
    title: "Request & Schedule",
    description: " Receptionist approves; reminders auto-send.",
  },
  {
    number: "02",
    icon: Stethoscope,
    title: "Consult & Prescribe",
    description: " Updates diagnosis; generates e-prescription PDF",
  },
  {
    number: "03",
    icon: FlaskConical,
    title: "Test & Report",
    description: " Results uploaded → doctor & patient notified.",
  },
  {
    number: "04",
    icon: TrendingUp,
    title: "Track & Improve",
    description: "Admin monitors KPIs, audits activity, optimizes staffing & hours.",
  },
];

// Highlights Section
const highlightsData = [
  {
    title: "Unified Calendar & Availability",
    text: "Day/week/month views, on-call rules, clinic hours/holidays",
  },
  {
    title: "Lab Workflows",
    text: "Test catalogs & combos, urgency flags, preferred lab routing, results viewer.",
  },
  {
    title: "Notifications",
    text: "In-app + Email/SMS/WhatsApp (TRAI DLT-compliant templates).",
  },
  {
    title: "Reporting & Analytics",
    text: "Appointment volume, no-show rate, lab TAT, doctor utilization; CSV/PDF export.",
  },
  {
    title: "Digital Prescriptions",
    text: "Structured, downloadable PDFs with dosage notes and history.",
  },
  {
    title: "APIs & Integrations",
    text: "REST JSON & webhooks; HL7/FHIR bridges where required; SSO/OAuth optional.",
  },
];

// Pricing Plans
const pricingPlans = [
  {
    name: "Clinic",
    subtitle: "For single-location practices",
    features: [
      "Appointments, e-Rx, basic lab workflows",
      "1 location, up to X doctors, Y staff seats",
      "Standard support (IST business hours)",
    ],
    link: "/plan/clinic",
  },
  {
    name: "Multi-Clinic",
    subtitle: "For growing groups",
    features: [
      "Everything in Clinic + multi-location + advanced reports",
      "Up to N locations, X doctors/location",
      "Priority support · Custom roles/permissions",
    ],
    link: "/plan/multiclinic",
  },
  {
    name: "Hospital Network",
    subtitle: "For large orgs",
    features: [
      "Everything in Multi-Clinic + multi-lab, SSO/SAML, VAPT reports",
      "Unlimited locations & labs · Single-tenant/VPC options",
      "Dedicated success manager",
    ],
    link: "/plan/network",
  },
];

const Section = ({ id, title, children, bg }) => (
  <section id={id} className={`lp-section ${bg ? "bg-" + bg : ""}`}>
    <Container>
      {title && <h2 className="section-title text-center mb-5">{title}</h2>}
      {children}
    </Container>
  </section>
);
const moduleConfig = {
  Administrative: labtechnician,
  Patient: patient,
  "Lab/Technician": labtechnician,
  Receptionist: receptionist,
  "OPD/Daycare": opd,
  Payroll: payroll,
  "Blood Bank": bloodbank,
  CSSD: cssd,
  "IPD & Emergency": daycare,
  TPA: tpa,
  Doctor: doctor,
  "LIS/RIS": lis,
  Pharmacy: pharmacy,
  MRD: mrd,
  "Bio Waste": biowaste,
  "Purchase & Inventory": accounts,
  CRM: crm,
  Accounts: accounts,
  Asset: asset,
  Ambulance: ambulance,
};

const handleDownloadBrochure = async () => {
  try {
    const response = await fetch(`${BASE_URL}/api/superadmin/download`, {
      method: "GET",
    });

    if (!response.ok) {
      throw new Error("Failed to download brochure");
    }

    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "brochure.pdf");
    document.body.appendChild(link);
    link.click();
    link.remove();
  } catch (error) {
    console.error("Download error:", error);
  }
};



const LandingPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [hovered, setHovered] = useState(false);
  const [showEnquiry, setShowEnquiry] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [activeModule, setActiveModule] = useState("Administrative");
  const [blogs, setBlogs] = useState([]);
  const latestBlogs = [...blogs]
    .sort((a, b) => new Date(b.published_date) - new Date(a.published_date))
    .slice(0, 3);

  const leftRef = useRef(null);
  const imgRef = useRef(null);
  const leftRef2 = useRef(null);
  const imgRef2 = useRef(null);

  useEffect(() => {
    const setImageHeight = () => {
      if (leftRef.current && imgRef.current) {
        const leftHeight = leftRef.current.offsetHeight;
        imgRef.current.style.height = leftHeight + "px";
      }
    };

    setImageHeight();
    window.addEventListener("resize", setImageHeight);

    return () => window.removeEventListener("resize", setImageHeight);
  }, []);



  useEffect(() => {
    const setHeight2 = () => {
      if (leftRef2.current && imgRef2.current) {
        imgRef2.current.style.height =
          leftRef2.current.offsetHeight + "px";
      }
    };

    setHeight2();
    window.addEventListener("resize", setHeight2);

    return () => window.removeEventListener("resize", setHeight2);
  }, [activeModule]);   

  const [loading, setLoading] = useState(false);

  const handleReadMore = (id) => {
    navigate(`/blogs2/${id}`);
  };
  useEffect(() => {
    fetchBlogs();
  }, []);
  const fetchBlogs = async () => {
    setLoading(true);
    try {
      const res = await fetch(`${BASE_URL}/api/superadmin/blogs`);
      if (!res.ok) throw new Error('Failed to fetch blogs');
      const data = await res.json();
      setBlogs(data || []);
    } catch (err) {
      console.error('Error fetching blogs:', err);
    } finally {
      setLoading(false);
    }
  };


  useEffect(() => {
    if (location.state?.scrollTo) {
      setTimeout(() => {
        scroller.scrollTo(location.state.scrollTo, {
          smooth: true,
          offset: -70,
          duration: 500,
        });
      }, 100); 
    }
  }, [location.state]);

  return (
    <div >
      {/* HERO SECTION */}

      <section
        className="hero-section text-white d-flex align-items-center"
        style={{
          minHeight: "80vh",
          backgroundImage: `url(${LandingPageHero})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <Container fluid>
          <Row className="w-100 align-items-center">
            <Col lg={6} md={12} xs={12} className="hero-text ps-lg-5 ps-md-3 ps-sm-2 ps-2 mx-4">
            <h2 className="fw-bold" style={{ fontSize: "clamp(1.5rem, 5vw, 3.5rem)", lineHeight: 1.2 }}>
              Run your hospital on one secure, India-hosted platform
            </h2>
            <p className="mt-4" style={{ fontSize: "clamp(0.9rem, 2vw, 1.1rem)", fontWeight: 500 }}>
              End-to-end operations for clinics and hospitals—appointments,
              lab requests/results, e-prescriptions, role-based dashboards,
              audit logs, and integrations that keep everyone in sync.
            </p>
            <div className="d-flex justify-content-start justify-content-md-center gap-2 flex-wrap mt-3">
              <Button
                size="sm"
                className="me-2 me-md-3 px-3 px-md-4 py-2 landing-primary-class how-card"
                style={{ fontSize: "clamp(0.75rem, 1vw, 0.9rem)" }}
                onClick={() => {
                  console.log("Book Demo Clicked")
                  setShowEnquiry(true)
                }}
              >
                Book a Demo →
              </Button>

              <Button
                size="sm"
                className="me-2 me-md-3 px-3 px-md-4 py-2 landing-primary-class how-card"
                style={{ fontSize: "clamp(0.75rem, 1vw, 0.9rem)" }}
                onClick={handleDownloadBrochure}
              >
                Download Brochure →
              </Button>
              <Button
                size="sm"
                className="me-2 me-md-3 px-3 px-md-4 py-2 landing-primary-class how-card"
                style={{ fontSize: "clamp(0.75rem, 1vw, 0.9rem)" }}
                onClick={() => setShowLoginPopup(true)}
              >
                Login Credentials →
              </Button>

            </div>
            </Col>
            <Col lg={6} md={12} xs={12}></Col>
          </Row>
        </Container>
      </section>
      <Modal
        show={showLoginPopup}
        onHide={() => setShowLoginPopup(false)}
        centered
        backdrop="static"
        keyboard={false}
        className="login-credential-modal"
      >
        <Modal.Header closeButton className="border-0 pb-0">
          <Modal.Title className="fw-bold primary-class">Login Credentials</Modal.Title>
        </Modal.Header>

        <Modal.Body className="px-4">
          <p className="text-muted mb-4">
            Use these demo credentials to explore different dashboards.
          </p>

          {/* Admin */}
          <div className="credential-box mb-3 p-3 rounded shadow-sm">
            <h6 className="fw-bold primary-class mb-1">Admin Login</h6>
            <p className="mb-0 small">
              <strong>Email:</strong> admin@example.com <br />
              <strong>Password:</strong> 123
            </p>
          </div>

          {/* Doctor */}
          <div className="credential-box mb-3 p-3 rounded shadow-sm">
            <h6 className="fw-bold primary-class mb-1">Doctor Login</h6>
            <p className="mb-0 small">
              <strong>Email:</strong> doctor@example.com <br />
              <strong>Password:</strong> 123
            </p>
          </div>
          {/* Reception */}
          <div className="credential-box p-3 rounded shadow-sm">
            <h6 className="fw-bold primary-class mb-1">Receptionist Login</h6>
            <p className="mb-0 small">
              <strong>Email:</strong> receptionist@example.com <br />
              <strong>Password:</strong> 123
            </p>
          </div>
          <div className="credential-box p-3 rounded shadow-sm">
            <h6 className="fw-bold primary-class mb-1">Patient Login</h6>
            <p className="mb-0 small">
              <strong>Email:</strong> patient@example.com <br />
              <strong>Password:</strong> 123
            </p>
          </div>
          <div className="credential-box p-3 rounded shadow-sm">
            <h6 className="fw-bold primary-class mb-1">Lab Login</h6>
            <p className="mb-0 small">
              <strong>Email:</strong> lab@example.com <br />
              <strong>Password:</strong> 123
            </p>
          </div>
        </Modal.Body>

        <Modal.Footer className="border-0">
          <Button
            className="landing-primary-class how-card px-4"
            onClick={() => setShowLoginPopup(false)}
          >
            Close
          </Button>
        </Modal.Footer>
      </Modal>




      {/* WHY HOSPEASE SOLUTION */}
      <section id="why" className="why-section py-5 mx-lg-4 mx-md-2 mx-2 px-3">
        <Container fluid>
          <SectionHeading title="Why HospEase Solution" />

          <Row className="g-3 g-md-4 align-items-start">
            <Col lg={6} md={12} xs={12}>
              <div ref={leftRef}>
                {whyFeatures.map((feature, i) => (
                  <FeatureCard
                    key={i}
                    icon={feature.icon}
                    iconSize={feature.iconSize}
                    title={feature.title}
                    description={feature.description}
                  />
                ))}
              </div>
            </Col>

            <Col lg={6} md={12} xs={12}>
              <img
                ref={imgRef}
                src={LandingPage2}
                alt="Why HospEase"
                className="why-image"
                style={{ width: "100%", height: "auto" }}
              />
            </Col>
          </Row>
        </Container>
      </section>


      {/*Core Modules */}
      <section className="py-2 mx-lg-4 mx-md-2 mx-2 bg-white px-3">
        <Container fluid>
          {/* Heading */}
          <SectionHeading
            title="Core Modules"
          />
          <p className="mt-2 mx-auto primary-class text-center" style={{ maxWidth: "85%", fontSize: "clamp(0.9rem, 2vw, 1rem)" }}>
            HospEase Solution Integrated modules work together harmoniously
            to provide a comprehensive method of managing healthcare.
          </p>

          {/* Tabs */}
          <div className="d-flex align-items-center mb-3 overflow-x-auto">


            <div className="d-flex overflow-auto py-2 gap-2" style={{
              scrollbarWidth: "thin",
              scrollbarColor: "#0a7884 transparent",
              minWidth: "100%",
            }}>
              {moduleTabs.map((module) => {
                const isActive = activeModule === module;

                return (
                  <Button
                    key={module}
                    onClick={() => setActiveModule(module)}
                    className="fw-medium feature-card flex-shrink-0"
                    style={{
                      backgroundColor: isActive ? "#0a7884" : "#fff",
                      color: isActive ? "#fff" : "#0a7884",
                      border: "2px solid #025d74",
                      whiteSpace: "nowrap",
                      fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)",
                      padding: "0.5rem 1rem",
                    }}
                  >
                    {module}
                  </Button>
                );
              })}
            </div>

          </div>
          {/* Content */}
          <Row className="align-items-start mt-4 g-3 g-md-4">
            <Col lg={5} md={12} xs={12}>
              <div ref={leftRef2}>
                <h5 className="fw-bold mb-3" style={{ fontSize: "clamp(1.1rem, 3vw, 1.5rem)" }}>{activeModule}</h5>
                <ul className="ps-3 text-muted" style={{ fontSize: "clamp(0.85rem, 1.5vw, 0.95rem)" }}>
                  {modulesData[activeModule].points.map((item, i) => (
                    <li key={i} className="mb-2">
                      {item}
                    </li>
                  ))}
                </ul>
              </div>
            </Col>
            <Col lg={7} md={12} xs={12} className="text-center">
              <img
                ref={imgRef2}
                src={modulesData[activeModule].image}
                alt={activeModule}
                className="core-module-image"
                style={{ width: "100%", height: "auto", maxHeight: "400px", objectFit: "contain" }}
              />
            </Col>

          </Row>
        </Container>
      </section>


      {/* Modules */}
      <section id="modules" className="modules-section py-3 mx-lg-4 mx-md-2 mx-3">
        <Container fluid>
          <SectionHeading title="Modules" />

          <div className="modules-grid">
            {moduleTabs.map((module) => {
              const slug = module
                .toLowerCase()
                .replace(/&/g, "and")
                .replace(/[^a-z0-9]+/g, "-")
                .replace(/(^-|-$)/g, "");

              return (
                <div
                  key={module}
                  role="button"
                  tabIndex={0}
                  className="module-card"
                  onClick={() => navigate(`/service/${slug}`)}
                  onKeyDown={(e) => {
                    if (e.key === "Enter" || e.key === " ")
                      navigate(`/service/${slug}`);
                  }}
                >
                  <div className="module-card-inner">
                    <div>
                      <img
                        src={moduleConfig[module]}
                        alt={module}
                        width={48}
                        height={48}
                        className="me-3 mt-1"
                      />
                    </div>
                    <div className="module-card-label">{module}</div>
                  </div>
                </div>
              );
            })}
          </div>
        </Container>
      </section>

      {/* HOW IT WORKS */}
      <section id="how" className="how-section py-5 bg-light mx-lg-4 mx-md-2 px-3">
        <Container fluid>
          <SectionHeading title="How It Works" />

          <Row className="g-3 g-md-4">
            {howItWorksSteps.map((step, i) => (
              <Col md={6} xs={12} key={i}>
              <StepCard
                number={step.number}
                icon={step.icon}
                title={step.title}
                description={step.description}
              />
            </Col>
          ))}
        </Row>
        </Container>
      </section>

      {/* HIGHLIGHTS */}
      <section className="py-2 bg-white mx-lg-4 mx-md-2 px-3">
        <Container fluid>
          <SectionHeading title="Highlights" />

          <Row className="g-3 g-md-4">
            {highlightsData.map((h, i) => (
              <Col md={6} xs={12} key={i}>
                <NumberedCard
                  number={i + 1}
                  title={h.title}
                  text={h.text}
                />
              </Col>
            ))}
          </Row>
        </Container>
      </section>

      {/* PRICING */}
      <section id="pricing" className="py-5 mx-lg-4 mx-md-2 px-3">
        <SectionHeading title="Pricing" />

        <Container fluid>
          <Row className="g-3 g-md-4 text-center">
            {pricingPlans.map((plan, i) => (
              <Col lg={4} md={6} xs={12} key={i}>
                <PricingCard
                  name={plan.name}
                  subtitle={plan.subtitle}
                  features={plan.features}
                  link={plan.link}
                />
              </Col>
            ))}
          </Row>

          {/* Bottom Buttons */}
          <div className="d-flex justify-content-center gap-2 gap-md-3 flex-wrap mt-4">
            <Button
              size="sm"
              className="px-3 px-md-4 py-2 landing-primary-class"
              style={{ fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)" }}
            >
              Compare Plans
            </Button>

            <Button
              size="sm"
              className="px-3 px-md-4 py-2 landing-primary-class"
              style={{ fontSize: "clamp(0.8rem, 1.5vw, 0.95rem)" }}
            >
              Request Custom Quote
            </Button>
          </div>

        </Container>
      </section>


      {/* SECURITY */}
      <section id="security" className="py-5 bg-light mx-lg-4 mx-md-2 px-3">
        <Container fluid>
          <SectionHeading title="Security & Compliance" />

          <Row className="g-3 g-md-4">
            {features.map((f, i) => (
              <Col md={6} xs={12} key={i}>
                <Card className="feature-card">
                  <Card.Body className="d-flex align-items-start">
                    <img
                      src={f.image}
                      alt={f.title}
                      width={28}
                      height={28}
                      className="me-3 mt-1"
                    />

                    <div>
                      <Card.Title className="fw-bold role-title">
                        {f.title}
                      </Card.Title>
                      <Card.Text className="text-muted">
                        {f.description}
                      </Card.Text>
                    </div>

                  </Card.Body>
                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>


      {/* INTEGRATIONS */}
      <section className="py-4 mx-lg-4 mx-md-2 mx-2 bg-white px-3">
        <Container fluid>
          <SectionHeading title="Integrations" />

          {/* Cards */}
          <Row className="g-3 g-md-4">
            {integrations.map((item, index) => (
              <Col key={index} xs={12} sm={6} lg={3}>
                <Card className="h-100 text-center feature-card">

                  {/* Icon */}
                  <div className="d-flex justify-content-center mt-4">
                    <div className="integration-icon-box">
                      <img src={integration} alt="integration" />
                    </div>
                  </div>

                  {/* Content */}
                  <Card.Body className="px-4 pb-4">
                    <Card.Title className="fw-bold primary-class mt-3">
                      {item.title}
                    </Card.Title>
                    <Card.Text className="text-muted small">
                      {item.description}
                    </Card.Text>
                  </Card.Body>

                </Card>
              </Col>
            ))}
          </Row>
        </Container>
      </section>



      {/* Blogs And News */}
      <section className="blogs-section py-3 mx-lg-4 mx-md-2 px-3">
        <Container fluid>
          <SectionHeading title="Blogs and News" />

          {loading ? (
            <div className="text-center py-5">
              <p>Loading blogs...</p>
            </div>
          ) : latestBlogs.length > 0 ? (
            <Row className="g-3 g-md-4">
              {latestBlogs.map((blog) => (
                <Col key={blog.id} md={6} lg={4} xs={12} className="mb-4">
                  <Card className="blog-card h-100">
                    {/* Blog Image */}
                    <div className="blog-image-wrapper">
                      {blog.title1_image ? (
                        <Card.Img
                          variant="top"
                          src={blog.title1_image}
                          alt={blog.title1}
                          className="blog-image"
                        />
                      ) : (
                        <div className="blog-image-placeholder">No Image</div>
                      )}
                    </div>

                    <Card.Body className="d-flex flex-column">
                      {/* CATEGORY */}
                      <div
                        className="align-self-start text-uppercase fw-semibold primary-class mb-1"
                        style={{ fontSize: '0.6rem' }}
                      >
                        {blog.category}
                      </div>

                      {/* TITLE */}
                      <Card.Title className="fw-bold mb-2">
                        {blog.title1}
                      </Card.Title>

                      {/* DESCRIPTION */}
                      <Card.Text className="blog-excerpt mb-3">
                        {blog.short_description}
                      </Card.Text>

                      {/* SEPARATOR LINE */}
                      <hr className="my-1" />

                      {/* DATE + BUTTON (SAME LINE) */}
                      <div className="d-flex justify-content-between align-items-center " style={{ fontSize: '0.8rem' }}>
                        {/* DATE */}
                        {blog.published_date && (
                          <small className="text-muted">
                            {new Date(blog.published_date).toLocaleDateString()}
                          </small>
                        )}

                        {/* BUTTON */}
                        <Button
                          variant="outline-custom"
                          className="btn-read-more rounded-5"
                          onClick={() => handleReadMore(blog.id)}
                        >
                          Read More
                        </Button>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          ) : (
            <div className="text-center py-5">
              <p>No blogs found.</p>
            </div>
          )}
        </Container>
      </section>


      {/* FAQ SECTION */}
      <Section id="faq" bg="light" className="mx-lg-4 mx-md-2 px-3">
        <Container fluid>
          <SectionHeading title="FAQs" />

          <Accordion flush>
            <Accordion.Item eventKey="0" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">Is our data stored in India?</span>
              </Accordion.Header>
              <Accordion.Body>
                Yes—AWS Mumbai or Hyderabad, with in-region backups.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="1" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">Are you DPDP-aligned?</span>
              </Accordion.Header>
              <Accordion.Body>
                Yes, we are DPDP-aligned for consent, purpose limitation, minimization & deletion workflows.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="2" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">Do you support ABDM?</span>
              </Accordion.Header>
              <Accordion.Body>
                Yes, we support ABDM integration with FHIR R4 adapters.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="3" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">How do SMS reminders work with DLT?</span>
              </Accordion.Header>
              <Accordion.Body>
                SMS reminders are sent via TRAI DLT-compliant templates.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="4" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">Do you handle WhatsApp reminders?</span>
              </Accordion.Header>
              <Accordion.Body>
                Yes, WhatsApp reminders are supported via approved WABA/BSP providers.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="5" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">Can you migrate our data?</span>
              </Accordion.Header>
              <Accordion.Body>
                Yes, we provide secure data migration support.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="6" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">What support do we get?</span>
              </Accordion.Header>
              <Accordion.Body>
                Standard and priority support options available based on plan.
              </Accordion.Body>
            </Accordion.Item>

            <Accordion.Item eventKey="7" className="m-2">
              <Accordion.Header>
                <span className="fw-bold">What’s your SLA?</span>
              </Accordion.Header>
              <Accordion.Body>
                We provide guaranteed uptime and SLA-backed commitments.
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>

          {/* CTA Section */}
          <div className="text-center mt-5 px-2 px-md-4">
            <h4 className="fw-bold mb-4" style={{ fontSize: "clamp(1.2rem, 3vw, 1.8rem)" }}>
              Manage your entire patient journey in one place.
            </h4>
            <div className="d-flex justify-content-center gap-2 gap-md-3 flex-wrap">
              <Button
                size="sm"
                className="me-1 me-md-2 px-3 px-md-4 py-2 landing-primary-class how-card"
                style={{ fontSize: "clamp(0.75rem, 1.5vw, 0.9rem)" }}
                onClick={() => {
                  console.log("Book Demo Clicked")
                  setShowEnquiry(true)
                }}
              >
                Book a Demo →
              </Button>
              <Button size="sm" className="me-1 me-md-2 px-3 px-md-4 py-2 landing-primary-class how-card" style={{ fontSize: "clamp(0.75rem, 1.5vw, 0.9rem)" }}>
                Explore Sandbox
              </Button>
              <Button size="sm" className="me-1 me-md-2 px-3 px-md-4 py-2 landing-primary-class how-card" style={{ fontSize: "clamp(0.75rem, 1.5vw, 0.9rem)" }}>
                Download Brochure
              </Button>
            </div>
          </div>
        </Container>
      </Section>

      {/* Floating Button */}
      <Button
        onClick={() => setShowEnquiry(true)} 
        className="landing-primary-class how-card d-flex align-items-center justify-content-center gap-2 enquiry-btn px-3"
        onMouseEnter={() => setHovered(true)}
        onMouseLeave={() => setHovered(false)}
      >
        <span>{hovered ? "Enquire Now" : "EQ"}</span>
        <ArrowUpRight size={20} style={{ transform: "rotate(75deg)" }} />
      </Button>

      <EnquiryModal
        show={showEnquiry}
        handleClose={() => setShowEnquiry(false)}
      />

      {/* Floating Enquiry Now Button */}
      <EnquiryModal
        show={showEnquiry}
        handleClose={() => setShowEnquiry(false)}
      />

    </div>
  );
}






export default LandingPage;